// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnrollmentCaseRelationshipsModel } from './enrollmentCaseRelationshipsModel.js';
import type { EnrollmentEligibilityModel } from './enrollmentEligibilityModel.js';
import type { EnrollmentMemberNumberModel } from './enrollmentMemberNumberModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentModel {
    'id'?: number;
    'memberNumber'?: string;
    'paymentTypeCode'?: string;
    'status'?: EnrollmentEligibilityModel | null;
    'updateCaseIds': Array<number>;
    'caseId'?: number;
    'memberNumbers': Array<EnrollmentMemberNumberModel>;
    'linkedEntities'?: EnrollmentCaseRelationshipsModel | null;
    'createdOn'?: Moment;
    'createdBy'?: number;
    'updatedBy'?: number;
    'updatedOn'?: Moment;
    'caseSourceId'?: number;
    'maxBenefit'?: string;
    'maxBenefitAmount'?: number;
    'untrackedBenefit'?: boolean;
    'householdSize'?: number;
    'startDate'?: Moment;
    'endDate'?: Moment;
    'claimEligibilityDate'?: Moment;
    'reenrollmentEligibilityDate'?: Moment;
    'paymentType'?: number;
    'isOptedIn'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentModel>> = [
        {
            "name":     "id",
            "baseName": "id",
            "type":     "number"
        },
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
        {
            "name":     "paymentTypeCode",
            "baseName": "paymentTypeCode",
            "type":     "string"
        },
        {
            "name":     "status",
            "baseName": "status",
            "type":     "EnrollmentEligibilityModel"
        },
        {
            "name":     "updateCaseIds",
            "baseName": "updateCaseIds",
            "type":     "Array<number>"
        },
        {
            "name":     "caseId",
            "baseName": "caseId",
            "type":     "number"
        },
        {
            "name":     "memberNumbers",
            "baseName": "memberNumbers",
            "type":     "Array<EnrollmentMemberNumberModel>"
        },
        {
            "name":     "linkedEntities",
            "baseName": "linkedEntities",
            "type":     "EnrollmentCaseRelationshipsModel"
        },
        {
            "name":     "createdOn",
            "baseName": "createdOn",
            "type":     "Date"
        },
        {
            "name":     "createdBy",
            "baseName": "createdBy",
            "type":     "number"
        },
        {
            "name":     "updatedBy",
            "baseName": "updatedBy",
            "type":     "number"
        },
        {
            "name":     "updatedOn",
            "baseName": "updatedOn",
            "type":     "Date"
        },
        {
            "name":     "caseSourceId",
            "baseName": "caseSourceId",
            "type":     "number"
        },
        {
            "name":     "maxBenefit",
            "baseName": "maxBenefit",
            "type":     "string"
        },
        {
            "name":     "maxBenefitAmount",
            "baseName": "maxBenefitAmount",
            "type":     "number"
        },
        {
            "name":     "untrackedBenefit",
            "baseName": "untrackedBenefit",
            "type":     "boolean"
        },
        {
            "name":     "householdSize",
            "baseName": "householdSize",
            "type":     "number"
        },
        {
            "name":     "startDate",
            "baseName": "startDate",
            "type":     "Date"
        },
        {
            "name":     "endDate",
            "baseName": "endDate",
            "type":     "Date"
        },
        {
            "name":     "claimEligibilityDate",
            "baseName": "claimEligibilityDate",
            "type":     "Date"
        },
        {
            "name":     "reenrollmentEligibilityDate",
            "baseName": "reenrollmentEligibilityDate",
            "type":     "Date"
        },
        {
            "name":     "paymentType",
            "baseName": "paymentType",
            "type":     "number"
        },
        {
            "name":     "isOptedIn",
            "baseName": "isOptedIn",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentModel.attributeTypeMap;
    }
}
